import { CloseOutlined, DeleteOutlined, EditOutlined, PlusCircleFilled, PlusOutlined } from "@ant-design/icons";
import { Card, Col, Input, Popconfirm, Row, Spin, Table, Modal, Button, Form, Upload, message } from "antd";
import { useEffect, useState } from "react";
import excel from "../assets/vector-icons/excel.png";

import search from "../assets/vector-icons/search.png";
import ApiClient from "../../helpers/ApiClient";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

const GuestImageUpload = (props) => {

    const BASE = process.env.REACT_APP_BASE_URL;
    const uploadActionUrl = BASE + "media/upload/multipleImages";
    // const uploadActionUrl=null;


    const [form] = Form.useForm();


    const [guestImagesList, setGuestImagesList] = useState([]);
    const [showSearchBox, setShowSearchBox] = useState(false);
    const [loading, setLoading] = useState(false);
    const [excelList, setExcelList] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const initialImages = {
        previewVisible: false,
        previewImage: "",
        previewTitle: "",
        fileList: [],
    };
    const [guestImages, setGuestImages] = useState(initialImages);
    const [dataSource, setDataSource] = useState([]);
    const [guestImagesId,setGuestImagesID]=useState(null)
    

    useEffect(()=>{
        getGuestImages()
    },[])

      const showModal = () => {
    // if (isEdit) {
    //   setIsEdit(false);
      form.resetFields();
      setGuestImages(initialImages);
    // }
    setModalVisible({
      visible: true,
    });
  };
    const searchTableData = (e) => {
        var searchVal = e.target.value;
        if (searchVal.length > 0) {
            const searchResults = dataSource.filter(function (item) {
                if (item != undefined) {
                    return JSON.stringify(item)
                        .toLowerCase()
                        .includes(searchVal.toLowerCase());
                }
            });
            setDataSource(searchResults);
        } else {
            getGuestImages();
        }
    };


    const searchData = () => {
        setShowSearchBox(true);
    };

    const closeSearch = () => {
        setLoading(false);
        getGuestImages();
        setShowSearchBox(false);
    };

    const closeSearchInput = (
        <div>
            <CloseOutlined onClick={closeSearch} />
        </div>
    );

    const add = () => {
        form.resetFields();
        if (isEditMode) {
            setIsEditMode(false);
            //   setContent(initialState);
            //   setSliderImage([]);
            //   setThumbnailImage([]);
        }
        setModalVisible(true);
    };

    let lastIndex = 0;
    const uniqueId = () => {
        lastIndex++;
        return lastIndex;
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    const handleCancel = (type) => {
        if (type === "guest") {
            setGuestImages((prev) => ({ ...prev, previewVisible: false }));
        }
    };

    const handlePreview = async (file, type) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        if (type === "guest") {
            setGuestImages((prev) => ({
                ...prev,
                previewImage: file.url || file.preview,
                previewVisible: true,
                previewTitle:
                    file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
            }));
        }

    };

    const handleChange = (data, type) => {
        if (type === "guest") {
            setGuestImages((prev) => ({ ...prev, fileList: data.fileList }));
        }
    };

    const tableActions = (currentData) => {
        return (
            <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                <div className="edit-icon" style={{ textAlign: "center" }}>
                    <EditOutlined
                        onClick={() => updateGuestImages(currentData)}
                        style={{ color: "#1890ff", fontSize: "20px", textAlign: "center" }}
                    />
                    {/* <InfoCircleOutlined onClick={openUserInfo} style={{ color: '#1890ff', fontSize: '20px', textAlign: 'center', marginLeft: "25px" }} /> */}
                </div>
                <div className="edit-icon" style={{ textAlign: "center" }}>
                    <Popconfirm
                        title="Are you sure to delete?"
                        onConfirm={() => deleteGuestImages(currentData.GuestImagesID)}
                    >
                        <DeleteOutlined
                            style={{ color: "red", fontSize: "20px", textAlign: "center" }}
                        />
                    </Popconfirm>
                </div>
            </div>
        );
    };

    const columns = [
        {
            title: "S.No.",
            dataIndex: "SNo",
            key: "sno",
        },
        {
            title: "Image",
            dataIndex: "GuestImage1",
            key: "image",
            render: (text, record) => (
                <img
                    src={BASE + record.GuestImage1.substring(1)} 
                    alt="Guest"
                    style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4 }}
                />
            ),
        },
        {
            title: "ImagePath",
            dataIndex: "GuestImage1",
        },
        {
            title: "Actions",
            render: (currentData) => tableActions(currentData),
        },
    ];

    const submitForm = (values) => {
        if (values.guestImages.fileList.length === 1) {
            if (
                values.guestImages.fileList[0].response.status !== 200 
                // &&
                // values.guestImages.fileList[1].response.status !== 200 &&
                // values.guestImages.fileList[2].response.status !== 200
            ) {
                form.setFields([
                    {
                        name: "guestImages",
                        errors: ["Image Error. Change Image"],
                    },
                ]);
                return;
            }
        } else {
            form.setFields([
                {
                    name: "guestImages",
                    errors: ["1 Image Required"],
                },
            ]);
            return;
        }

        let formData = {
            GuestImage1: values.guestImages.fileList[0].response.data.filepaths[0],
            // GuestImage2: values.guestImages.fileList[1].response.data.filepaths[0],
            // GuestImage3: values.guestImages.fileList[2].response.data.filepaths[0],
        };

        isEditMode ? putGuestImages(formData) : postGuestImages(formData);
    };

    const getGuestImages = () => {
    ApiClient.get("admin/guestImages")
      .then((res) => {
        if (res.status == 200) {
          const data = res.data.map((item, index) => {
            return {
              ...item,
              SNo: index + 1,
            };
          });
          setDataSource(data);
        } else {
          message("Server Error");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

     const postGuestImages = (formData) => {
        ApiClient.post("admin/guestImages", formData).then((res) => {
          if (res.status == 200) {
            message.success("Guest Images added successfully", 3);
            getGuestImages();
            setModalVisible(false);
            form.resetFields();
            setGuestImages(initialImages);
            // setHotelImages(initialImages);
          } else {
            message.error(" Error Uploading Data", 3);
          }
        });
      };

    const deleteGuestImages = (id) => {
        ApiClient.delete("admin/guestImages/" + id)
            .then((res) => {
                if (res.status == 200) {
                    message.success("Guest Image Deleted  successfully", 3);
                    getGuestImages();
                } else {
                    message.error("Error Deleting", 3);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

     const updateGuestImages = (record) => {
      setIsEditMode(true);
      setGuestImagesID(record.GuestImagesID)
    let guestImages = [
      {
        uid: "1",
        name: "slide.jpg",
        status: "done",
        url: BASE + record.GuestImage1.substring(1),
        response: {
          status: 200,
          data: {
            filepaths: [record.CityImage1],
          },
        },
      },
    ];
    form.setFieldsValue({
      guestImages: { fileList: guestImages },
    });

    setGuestImages((prev) => ({ ...prev, fileList: guestImages }));
    setModalVisible(true);
  };

      const putGuestImages = (formData) => {
       ApiClient.put("admin/guestImages/" + guestImagesId, {}, formData).then(
        (res) => {
        if (res.status == 200) {
          message.success("Guest Images Updated  successfully", 3);
          setModalVisible(false);
          form.resetFields();
          setGuestImages(initialImages);
          getGuestImages();
        } else {
          message.error(" Error Uploading Data", 3);
        }
      }
    );
  };

    return (
        <div className="promo">
            <div className="manage-markup-section">
                <div className="admin-container">
                    <Row>
                        <Col span={24}>
                            <div className="card-bt-gap">
                                <Card bordered={false}>
                                    <div className="card-add-heading">
                                        {/* <div className="table-heading-count"> */}
                                        <div className="rows-count">
                                            <div>
                                                <h5>
                                                    Guest Images{" "}
                                                    {/* <HelpInfoHelper screenName={"/admin/activities"} /> */}
                                                </h5>
                                                <p>{dataSource.length} rows found !</p>
                                            </div>
                                        </div>
                                        <div className="action-images">
                                            {showSearchBox && (
                                                <Input
                                                    placeholder="Search"
                                                    onChange={(e) => searchTableData(e)}
                                                    suffix={closeSearchInput}
                                                    style={{ padding: "0px 12px" }}
                                                />
                                            )}
                                            &nbsp;&nbsp;
                                            <img
                                                src={search}
                                                alt="search"
                                                onClick={(e) => searchData()}
                                            />
                                            <img
                                                src={excel}
                                                alt="excel"
                                                onClick={(e) => props.exportExcel(excelList, "tour")}
                                            />
                                            <p className="add-deposit-icon" onClick={showModal}>
                                                <PlusCircleFilled />
                                            </p>
                                        </div>
                                        {/* </div> */}
                                    </div>

                                    <div>

                                        {loading ? (
                                            <Spin
                                                size="large"
                                                tip="Loading..."
                                                style={{ width: "100%" }}
                                            />
                                        ) : dataSource.length > 0 ? (
                                            <Table
                                                className="table-data"
                                                style={{ scrollbarColor: '#eaeaea transparent' }}
                                                bordered
                                                dataSource={dataSource}
                                                columns={columns}
                                                rowKey={uniqueId}
                                                pagination={{
                                                    defaultPageSize: 25,
                                                    showSizeChanger: true,
                                                    pageSizeOptions: ["25", "50", "100", "125"],
                                                }}
                                            />
                                        ) : (
                                            <b>No Results Found!</b>
                                        )}
                                    </div>
                                </Card>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>

            <Modal
                title="Add Guest Images"
                className="promo-modal-header admin-bc-level"
                visible={modalVisible}
                onOk={(e) => setModalVisible(false)}
                onCancel={(e) => setModalVisible(false)}
                footer={[
                    <div>
                        <Button
                            key="add"
                            type="primary"
                            htmlType="submit"
                            className="edit-btn"
                            onClick={() => form.submit()}
                        >
                            {isEditMode ? "Update" : "Add"}
                        </Button>
                        <Button
                            type="primary"
                            danger
                            className="cancel-btn"
                            onClick={() => setModalVisible(false)}
                        >
                            Cancel
                        </Button>
                    </div>,
                ]}
                width={"1100px"}
            >

                <Form
                    form={form}
                    initialValues={{
                        Servicetype: 1,
                    }}
                    layout="vertical"
                    onFinish={submitForm}
                    style={{padding:'20px 30px'}}
                >
                    <Row gutter={[16, 16]}>
                        <Col md={6} xs={24}>
                            <Form.Item
                                label="Guest Images"
                                name="guestImages"
                                rules={[{ required: true, message: "Images are required" }]}
                            >
                                <Upload
                                    name="image"
                                    action={uploadActionUrl}
                                    listType="picture-card"
                                    fileList={guestImages.fileList}
                                    onPreview={(data) => handlePreview(data, "guest")}
                                    data={{ category: "guestimages" }}
                                    onChange={(data) => handleChange(data, "guest")}
                                >
                                    {guestImages.fileList.length >= 1 ? null : uploadButton}
                                </Upload>
                            </Form.Item>
                            <Modal
                                visible={guestImages.previewVisible}
                                title={guestImages.previewTitle}
                                footer={null}
                                onCancel={() => handleCancel("guest")}
                            >
                                <img
                                    alt="example"
                                    style={{ width: "100%" }}
                                    src={guestImages.previewImage}
                                />
                            </Modal>
                        </Col>
                    </Row>
                </Form>

            </Modal>
        </div>
    )
}

export default GuestImageUpload;